import { Component, ViewChild, ElementRef, ApplicationRef } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { NavController, NavParams, AlertController, Events, Platform, Content, LoadingController } from 'ionic-angular';
import { AppState, patronFields } from '../../config/state';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { AppScreen } from '../../providers/config/config';
import { AddressLookupProvider } from '../../providers/address-lookup/address-lookup';
import { LocationsProvider } from '../../providers/locations/locations';
import { PatronProvider } from '../../providers/patron/patron';
import { PatronFieldsProvider } from '../../providers/patronFields/patronFields.service';
import moment from 'moment';

/**
 * Generated class for the CoRoamPatronsignupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-roam-patronsignup',
  templateUrl: 'co-roam-patronsignup.html',
  providers: [
    PatronFieldsProvider
  ]
})

export class CoRoamPatronsignupPage {
  locationList: Array<any>;
  staffScreen: boolean = true;
  patronDetails: any;
  errorMessageObj: any;
  requiredFields: { };
  emailRegex: any;
  phoneRegex: any;
  invalidField: boolean = false;
  emptyField: boolean = false;
  isRootPage: boolean = false;
  enableBackButton: boolean = true;
  wideScreen: boolean;
  manualBlockOptions = [];
  residentCategoryOptions = [];
  cardCampaignOptions = [];
  patronTypeOptions = [];
  noticePreferenceOptions = [];
  hidePIN: boolean = false;
  patronFields: patronFields = {};
  minNewExpiryDate = "";
  submitting = false;
  private signup: FormGroup;
  // @ViewChild('addresssearch') addressSearch: AutoCompleteComponent;
  @ViewChild('addresssearch', { read: ElementRef }) addressSearch : ElementRef;
  @ViewChild(Content) content: Content
  private screenData: AppScreen;
  private clock: boolean;
  private menuSide = "right";
  constructor(public navCtrl: NavController, private _patronFields: PatronFieldsProvider, public navParams: NavParams, private alert: AlertController, private patronProvider: PatronProvider, private formBuilder: FormBuilder, public state: AppState, private toast : ToastAlertsProvider, private viewCtrl : ViewController, private events : Events, private timeout : TimeoutFunctionsProvider, private platform : Platform, private addressLookup : AddressLookupProvider, private locations: LocationsProvider, private app : ApplicationRef, private loading : LoadingController) {
    this.patronFields = this._patronFields.getFields();
    this.wideScreen = this.platform.width() > 600;
    this.screenData = this.navParams.data.screenData;
    this.clock = this.state.clockEnabledOnScreen;
    this.navCtrl.length() <= 1 ? this.isRootPage = true : this.isRootPage = false;
    this.navCtrl.length() <= 0 ? this.enableBackButton = false : this.enableBackButton = true;
    if (this.state.burgerMenu) {
      this.state.burgerMenu && this.state.burgerMenu.menuSide ? this.menuSide = this.state.burgerMenu.menuSide : this.menuSide = "hidden";
    }
    this.minNewExpiryDate = moment().add(1, 'days').format("YYYY-MM-DD");
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.signup = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.minLength(3)]],
      lastName: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email]],
      phone: [''],
      dob: [''],
      address1: [''],
      address2: [''],
      city: [''],
      state: [''],
	  zip: [''],
	  barcode: ['']
    });
    this.staffScreen = this.state.staff;
    this.patronDetails = {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      dob: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      barcode:"",
      homeBranchId:"",
      pin:"",
      expires: "",
      manualBlock: "",
      patronType: "",
      cardCampaign: "",
      residentCategory: "",
      notificationPreference: "",
      user1: "",
      user2: "",
      user3: "",
      user4: "",
      user5: ""
    }

    this.patronProvider.getPatronFormOptions().then((data) => {
        if (data.manualBlock) this.manualBlockOptions = data.manualBlock;
        if (data.patronTypes) this.patronTypeOptions = data.patronTypes;
        if (data.cardCampaign) this.cardCampaignOptions = data.cardCampaign;
        if (data.residentCategory) this.residentCategoryOptions = data.residentCategory;
        if (data.noticePreference) this.noticePreferenceOptions = data.noticePreference;
    });

    this.initFields();
    this.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.phoneRegex = new RegExp('^[^a-zA-Z]*$');
    let loader = this.loading.create({content: "Getting location..."});
    loader.present();
    // this.locations.getLocations().then(l=>this.locationList=l);

    this.locations.getUserLocation().then(coords =>{
      if (coords && coords.lat !== ''){
        this.locations.getNearestLocations(coords.lat, coords.lng).then(locations=>{
          loader.dismiss().catch(err=>{});
          this.locationList=locations.filter((x) => x.polarisId && x.polarisId != null);
          this.patronDetails.homeBranchId = locations[0].polarisId || '';
        });
      } else {
        this.locations.getLocations().then(locations => {
          loader.dismiss().catch(err=>{});
          this.locationList=locations.filter((x) => x.polarisId && x.polarisId != null);
          let setLoc = locations.find(b => b.id == this.state.locationId);
          this.patronDetails.homeBranchId = setLoc? setLoc.polarisId || '' : '';
        });
      }
    }).catch(err=>{
      this.locations.getLocations().then(locations => {
        loader.dismiss().catch(err=>{});
        this.locationList=locations.filter((x) => x.polarisId && x.polarisId != null);
        let setLoc = locations.find(b => b.id == this.state.locationId);
        this.patronDetails.homeBranchId = setLoc? setLoc.polarisId || '' : '';
      });
    })
  }

  ionViewDidLoad(){
    this.initAutocomplete();
  }

  initAutocomplete(): void {
    // console.log(search.nativeElement);
    if (this.addressSearch) {
    let addressElement = this.addressSearch.nativeElement.querySelector('.text-input');
    this.addressLookup.createAutocomplete(addressElement).subscribe((location) => {
      // console.log(location);
      //NEED TO use find because the api array output isn't always in order
      let streetNum = location.find(l => l.types[0] == 'street_number')? location.find(l => l.types[0] == 'street_number').long_name : '';
      let streetName = location.find(l => l.types[0] == 'route')? location.find(l => l.types[0] == 'route').long_name : '';

      this.patronDetails.address1 = `${streetNum} ${streetName}`;
      this.patronDetails.address2 = '';
      this.patronDetails.city = location.find(l => l.types[0] == 'locality')? location.find(l => l.types[0] == 'locality').long_name : '';
      this.patronDetails.state = location.find(l => l.types[0] == 'administrative_area_level_1')? location.find(l => l.types[0] == 'administrative_area_level_1').short_name : '';
      this.patronDetails.zip = location.find(l => l.types[0] == 'postal_code')? location.find(l => l.types[0] == 'postal_code').long_name : '';

      this.app.tick();
    });
  }
  }

  initFields() {
    this.requiredFields = {
      firstName: false,
      lastName: false,
      email: false,
      phone: false,
      barcode: false,
      pin: false
    };
  }

  submitForm() {

    let patronData = this.signup.value;
    let name = patronData.firstName + " " + patronData.lastName;

    if (this.signup.valid) {
      let alert = this.alert.create({
        title: 'Successfully submitted signup.',
        subTitle: `You have setup the patron: ${name}.`,
        cssClass: 'alertButton',
        buttons: ['OK']
      });

      alert.present();
      alert.onDidDismiss(() => {
        this.signup.reset();
      });
    }
  }
  scrollToInput(event){
    setTimeout(()=>event._elementRef.nativeElement.scrollIntoView(), 750);
  }
  resetRequiredFields() {
    Object.keys(this.patronDetails).forEach((field) => {
      this.requiredFields[field] = false;
    });
  }
  async validateInputs() {
    let passesValidation = true;
    this.resetRequiredFields();
    for (const key in this.patronDetails) {
      if (this.isEmptyAndRequired(key)) {
        this.requiredFields[key] = true;
        passesValidation = false;
      }
      switch (key) {
        case ('email'):
          if (!this.emailRegex.test(this.patronDetails.email) && this.patronDetails.email.length != 0) {
            this.requiredFields[key] = true;
            passesValidation = false;
          }
          break;
        case ('phone'):
          if (!this.phoneRegex.test(this.patronDetails.phone) || this.patronDetails.phone.length < 7 && this.patronDetails.phone.length != 0) {
            this.requiredFields[key] = true;
            passesValidation = false;
          }
          break;
      }
    }

    return passesValidation;
  }

  isEmptyAndRequired(field) {
    return this.patronDetails[field].length <= 0 && this.patronFields[field] && this.patronFields[field].required;
  }

  submitDetails(){
    this.validateInputs().then((result) => {
      if (result){
        this.submitting = true;
        this.patronProvider.createPatron(this.patronDetails).then((res)=>{
          this.submitting = false;
          if (!res || !res.status){
            this.toast.triggerToast(res.message,'','error', 3000);
          }else{
            this.toast.triggerToast((res.barcode ? `Patron created, new barcode is ${res.barcode}`:"Patron successfully created"),'','success', 10000);
            this.viewCtrl.dismiss().catch(err=>{});
          }
        });
      } else {

      }
    }).catch((err) => {

    });
  }



}



// WEBPACK FOOTER //
// ./src/pages/co-roam-patronsignup/co-roam-patronsignup.ts